module.exports = __webpack_public_path__ + "img/RECYCLE_BIN.5a98e741.svg";